/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_IntroInputs */

const en_gc_story_intro = /** @type {(inputs: Gc_Story_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft is the spreadsheet application from ArtCraft, an open-source software studio. Written in Rust, it combines an Excel-style ribbon, worksheet tabs and a formula bar with a calculation engine that runs on desktop computers and in the browser through WebAssembly.`)
};

const zh_gc_story_intro = /** @type {(inputs: Gc_Story_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 是开源软件工作室 ArtCraft 开发的电子表格应用。它用 Rust 编写，将类似 Excel 的功能区、工作表标签和公式栏，与可在桌面和浏览器 WebAssembly 中运行的计算引擎结合。`)
};

/**
* | output |
* | --- |
* | "GridCraft is the spreadsheet application from ArtCraft, an open-source software studio. Written in Rust, it combines an Excel-style ribbon, worksheet tabs an..." |
*
* @param {Gc_Story_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_intro = /** @type {((inputs?: Gc_Story_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_intro(inputs)
	return zh_gc_story_intro(inputs)
});
export { gc_story_intro as "gc.story.intro" }